<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Resultatrad
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Tabellrader i Degkalkylatorns resultatpanel. Varje rad visar en ingrediens
      med sin procentandel och grammvikt.
    </p>

    <PreviewFull label="Exempel — beräkningsresultat">
      <div
        class="w-full rounded-2xl overflow-hidden"
        style="border: 1px solid #eceef0"
      >
        <div
          v-for="row in rows"
          :key="row.label"
          class="flex items-center px-5 py-3"
          :class="row.bold ? 'bg-[#f8fafa]' : ''"
          style="border-bottom: 1px solid #f0f2f4"
        >
          <div class="flex items-center gap-2.5 flex-1">
            <span
              v-if="row.color"
              class="inline-block w-2.5 h-2.5 rounded-full"
              :style="{ background: row.color }"
            />
            <span
              class="font-[Plus_Jakarta_Sans] text-[14px]"
              :class="row.bold ? 'font-bold text-[#191c1e]' : 'text-[#3c4947]'"
              >{{ row.label }}</span
            >
          </div>
          <span
            v-if="row.pct !== null"
            class="font-[Plus_Jakarta_Sans] text-[13px] text-[#6c7a77] w-14 text-right"
            >{{ row.pct }}%</span
          >
          <span
            class="font-[Poppins] font-bold text-[14px] text-[#191c1e] w-16 text-right"
            >{{ row.grams }} g</span
          >
        </div>
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<div class="flex items-center gap-3 py-3 border-b border-[#eceef0] last:border-none">
  <span class="w-2.5 h-2.5 rounded-full flex-shrink-0" :style="{ background: row.color }" />
  <span class="flex-1 font-[Plus_Jakarta_Sans] text-[14px] text-[#191c1e]">{{ row.label }}</span>
  <span class="font-[Poppins] font-bold text-[14px] text-[#191c1e]">{{ row.value }}</span>
  <span class="font-[Plus_Jakarta_Sans] text-[13px] text-[#6c7a77] w-12 text-right">
    {{ row.pct }}%
  </span>
</div>`;
const cssCode = `/* Resultatrad */
display: flex;
align-items: center;
gap: 12px;
padding: 12px 20px;   /* py-3 px-5 */
border-bottom: 1px solid #f0f2f4;

/* Värde-font */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 14px;
color: #191c1e;

/* Summa-rad bakgrund */
background: #f8fafa;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
const rows = [
  { label: "Mjöl", grams: 500, pct: 100, color: "#f59e0b", bold: false },
  { label: "Vatten", grams: 350, pct: 70, color: "#0ea5e9", bold: false },
  { label: "Salt", grams: 10, pct: 2, color: "#94a3b8", bold: false },
  { label: "Färsk jäst", grams: 5, pct: 1, color: "#a78bfa", bold: false },
  { label: "Totalt", grams: 865, pct: null, color: null, bold: true },
];
</script>
